// 環境変数
app.value('serverConfig', {
    'serverUrl' :'https://lirs.jp',
    'apiUrl' : '/freeLiR/api'
})
